<template></template>

<script>
export default {
  name: "new"
};
</script>

<style scoped>
</style>